// Pure-CSS confetti rain — no Framer Motion dependency. 50 pieces with
// pseudo-random horizontal positions and animation delays. Honors
// prefers-reduced-motion via the .confetti-piece CSS rule.

const DEFAULT_COLORS = ['#fcd34d', '#fb7185', '#93c5fd', '#86efac', '#c4b5fd', '#fdba74'];
const PIECES = 50;

interface ConfettiProps {
  colors?: string[];
}

// Hash i into a stable 0..1 fraction so positions stay consistent across
// renders without an expensive Math.random in render.
function hash01(seed: number): number {
  const x = Math.sin(seed * 99991) * 10000;
  return x - Math.floor(x);
}

export function Confetti({ colors }: ConfettiProps = {}) {
  const palette = colors && colors.length > 0 ? colors : DEFAULT_COLORS;
  const pieces = Array.from({ length: PIECES }, (_, i) => {
    const left = hash01(i + 1) * 100;
    const delay = hash01(i + 7) * 1.2;
    const duration = 2.4 + hash01(i + 13) * 1.6;
    const color = palette[i % palette.length] ?? '#fcd34d';
    const size = 6 + Math.floor(hash01(i + 17) * 8);
    return (
      <span
        key={i}
        className="confetti-piece"
        style={{
          left: `${left}%`,
          background: color,
          width: `${size}px`,
          height: `${size}px`,
          animationDelay: `${delay}s`,
          animationDuration: `${duration}s`,
        }}
      />
    );
  });
  return (
    <div className="confetti" aria-hidden="true">
      {pieces}
    </div>
  );
}
